import ReactGA from "react-ga4";

// Load from .env file
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || "";

// Initialize GA
export const initGA = () => {
    if (GA_TRACKING_ID) {
        ReactGA.initialize(GA_TRACKING_ID);
        trackUserEngagement();
    } else {
        console.warn("GA Tracking ID is missing!");
    }
};

// Track page views
export const trackPageView = (path: string) => {
    if (GA_TRACKING_ID) {
        ReactGA.send({ hitType: "pageview", page: path });
    }
};

// Track custom events
export const trackEvent = (category: string, action: string, label?: string) => {
    if (GA_TRACKING_ID) {
        ReactGA.event({ category, action, label });
    }
};

// Track clicks on buttons/links
export const trackClick = (elementName: string) => {
    trackEvent("User Interaction", "Click", elementName);
};

// Track scroll depth
export const trackScrollDepth = () => {
    window.addEventListener("scroll", () => {
        const scrollY = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollY / docHeight) * 100;

        if (scrollPercentage > 25) trackEvent("Scroll", "25% Reached");
        if (scrollPercentage > 50) trackEvent("Scroll", "50% Reached");
        if (scrollPercentage > 75) trackEvent("Scroll", "75% Reached");
        if (scrollPercentage > 90) trackEvent("Scroll", "90% Reached");
    });
};

// Track user engagement time
const trackUserEngagement = () => {
    let startTime = Date.now();

    window.addEventListener("beforeunload", () => {
        const timeSpent = Math.round((Date.now() - startTime) / 1000);
        trackEvent("User Engagement", "Time Spent", `${timeSpent} seconds`);
    });
};

// Track outbound link clicks
export const trackOutboundLink = (url: string) => {
    trackEvent("Outbound Link", "Click", url);
};
